import {
  Drawer,
  Box,
  IconButton,
  Toolbar,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Close, MoreVert } from "@mui/icons-material";
import { DrawerNavMenu } from "./DrawerNavMenu";
// import { ThemeSwitch } from "./ThemeSwitch";
import { Logo } from "../logo/Logo";
import { UserMenu } from "../auth/UserMenu";
import { useDrawer } from "src/utils/useDrawer";
import { useAuth } from "src/utils/useAuth";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DRAWER_WIDTH = 307;

/**
 * Mobile navigation drawer (temporary overlay).
 *
 * Features:
 * - Modal overlay
 * - Auto-closes on route change
 * - Logo and app name at top
 * - Navigation menu items
 * - Theme toggle
 * - User profile at bottom
 */
export function DrawerMobile() {
  const { isOpen, hide } = useDrawer();
  const { isEnabled } = useAuth();
  const location = useLocation();

  // Auto-close drawer when route changes
  useEffect(() => {
    hide();
  }, [location.pathname, hide]);

  return (
    <Drawer
      variant="temporary"
      open={isOpen}
      onClose={hide}
      ModalProps={{
        keepMounted: true, // Better mobile performance
      }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: DRAWER_WIDTH,
        },
      }}
    >
      {/* Logo/Header with Close Button */}
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
        }}
      >
        <Logo height={48} />
        <IconButton onClick={hide} edge="end">
          <Close />
        </IconButton>
      </Toolbar>

      <Divider />

      {/* Navigation Menu */}
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <DrawerNavMenu />
      </Box>

      <Divider />

      {/* Theme Switch - hidden until dark mode is fully supported */}
      {/* <ThemeSwitch collapsed={false} /> */}

      {/* User Menu (Auth0 enabled) or App Menu (Auth0 disabled) */}
      {isEnabled ? (
        <UserMenu collapsed={false} />
      ) : (
        <Box sx={{ p: 1 }}>
          <ListItemButton
            sx={{
              px: 2,
              py: 1,
              minHeight: 48,
              maxHeight: 48,
            }}
          >
            <ListItemIcon>
              <MoreVert />
            </ListItemIcon>
            <ListItemText primary="App Menu" />
          </ListItemButton>
        </Box>
      )}
    </Drawer>
  );
}
